import ChatInterface from "@/components/chat/ChatInterface";

const Index = () => <ChatInterface />;

export default Index;